const TABS = ['Overview', 'Courses', 'Review'];

function CourseDetailTabs({ activeTab, onTabChange }) {
  return (
    <div className="flex items-center gap-1">
      {TABS.map((tab) => {
        const isActive = activeTab === tab;
        return (
          <button
            key={tab}
            type="button"
            onClick={() => onTabChange(tab)}
            className={
              isActive
                ? 'rounded-lg border border-[#9369CC]/35 bg-white px-8 py-2.5 text-sm font-semibold text-[#9369CC] shadow-[0_2px_8px_rgba(0,0,0,0.06)]'
                : 'px-5 py-2.5 text-sm font-medium text-[#666666] transition hover:text-[#1B1B1B]'
            }
          >
            {tab}
          </button>
        );
      })}
    </div>
  );
}

export default CourseDetailTabs;
